import Page from 'Scripts/classes/Page'
import Tracker from 'Scripts/components/Tracker'
import axios from 'axios'
import { getEmbeddedFeaturedImg, getEmbeddedTerm } from 'Scripts/utils/wordpress'
import { deviceType, getCookieValue } from 'Scripts/utils/utils'

export default class Realisation extends Page {
  constructor() {
    super('realisation', {
      container: '[data-mod = "realisation"]',
      elements: {
        links: '.animateImg',
        imgWrapper: '.realisationImg__wrapper',
        moduleItems: '[data-mod = "realisation"] .module__item',
        moduleImgItemsWrapper: '.realisationImg_items',
        moduleImgItems: '.realisationImg_item',
        paginationLink: '.module__btn_readmore a',
        moduleWrapper: '.module__wrapper',
        date: '.dropdown .dropdown__input_hidden[name="date"]',
        category: '.dropdown .dropdown__input_hidden[name="category"]',
        categoryItem: '.dropdown__list[name="category"] .dropdown__list_item',
        metier: '.dropdown .dropdown__input_hidden[name="metier"]',
        filterInput: '.dropdown .dropdown__input_hidden',
        layout: '.layout__wrapper a',
        count: '.filters .count__wrapper',
        mobileFilter: '[data-filter]',
        mobileLayout: '[data-layout]',
        mobileCount: '.result__count',
        mobileFilterResult: '.mobile__filters_wrapper .filters__footer_result',
        mobileCategoryFilters: '[data-filter="category"]',
      },
    })

    //Variables
    this.length = this.elements.moduleItems ? this.elements.moduleItems.length : 0

    this.device = deviceType()
    this.isMobile = this.device === 'mobile'
    this.isMobile && this.mobileFilter()

    //Language
    this.lang = getCookieValue('wp-wpml_current_language') || 'fr'
    // console.log(this.lang)

    //Methods
    // if (this.length > 0) {
    //   this.init()
    // }

    this.init()

    // this.updateCategoryList()
  }

  mobileFilter() {
    //nodelist to array

    // console.log([...this.elements.mobileFilter].filter(elm => elm.classList.contains('active') && elm.dataset.filter === 'metier')[0].dataset.value)
    this.elements.mobileFilter?.forEach((elm) => {
      elm.addEventListener('click', () => {
        // remove active class from all buttons of the same group
        const siblings = elm.parentNode.children
        for (let i = 0; i < siblings.length; i++) {
          siblings[i].classList.remove('active')
        }
        // add active class to the clicked button
        elm.classList.add('active')
        // get the clicked button's data-filter
        let metier = ''
        let category = ''

        // get others filters
        switch (elm.dataset.filter) {
          case 'category':
            category = elm.dataset.value
            metier = [...this.elements.mobileFilter].filter(
              (elm) => elm.classList.contains('active') && elm.dataset.filter === 'metier'
            )[0]?.dataset.value
            this.getProjects({
              metier,
              category,
              layout: [...this.elements.mobileLayout].filter((elm) =>
                elm.classList.contains('active')
              )[0]?.dataset.layout,
            })
            break
          case 'metier':
            this.updateCategoryList(elm.dataset.value)
            // metier = elm.dataset.value
            // category = [...this.elements.mobileFilter].filter(elm => elm.classList.contains('active') && elm.dataset.filter === 'category')[0]?.dataset.value
            break
        }
        //
        // this.getProjects({ metier, category, layout: [...this.elements.mobileLayout].filter(elm => elm.classList.contains('active'))[0]?.dataset.layout })
      })
    })
  }

  updateCategoryList(metier) {
    let categoryList = []
    // this.elements.metier.addEventListener('change', () => {

    //retrieve all project with the selected metier and update the category list
    // axios
    //   .get(
    //     `${process.env.API}/projets/?per_page=100&_fields=acf.metier,project_cat&lang=${this.lang}`
    //   )
    axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: 'projets',
        perPage: 100,
        _fields: 'acf.metier,project_cat',
        lang: this.lang,
      },
    }).then((response) => {
      //update category list
      if (metier) {
        categoryList = [
          ...new Set(
            response.data
              .filter((elm) => elm.acf.metier === parseInt(metier))
              .map((elm) => elm.project_cat[0])
          ),
        ]
      } else {
        categoryList = [...new Set(response.data.map((elm) => elm.project_cat[0]))]
      }
      //hide category that are not in the list
      if (!this.isMobile) {
        //Desktop device
        this.elements.categoryItem.forEach((item) => {
          if (categoryList.includes(parseInt(item.dataset.value))) {
            item.classList.remove('is__hidden')
          } else if (item.dataset.value !== '') {
            item.classList.add('is__hidden')
          }
        })
        //reinit category filter
        const allCategories = document.querySelector(
          `.dropdown__list[name='category'] .dropdown__list_item[data-value=""]`
        )
        allCategories.click()
      } else {
        //mobile devices
        // console.log(categoryList)
        this.elements.mobileCategoryFilters.forEach((item) => {
          if (categoryList.includes(parseInt(item.dataset.value))) {
            item.classList.remove('is__hidden')
          } else if (item.dataset.value !== '') {
            item.classList.add('is__hidden')
          }
        })
        const allCategories = document.querySelector(
          `.filters__list[name='category'] [data-value=""]`
        )
        allCategories.click()
      }
    })
    // })
  }

  getParam(urlParams, param) {
    return urlParams.has(param) && !isNaN(urlParams.get(param)) ? urlParams.get(param) : ''
  }

  init() {
    //get url param
    this.urlParams = new URLSearchParams(window.location.search)
    //
    this.metierParam = this.getParam(this.urlParams, 'metier')
    this.categoryParam = this.getParam(this.urlParams, 'category')
    // this.dateParam = this.getParam(this.urlParams, 'date')
    //
    const metierList =
      this.metierParam &&
      document.querySelector(`.dropdown__list_item[data-value="${this.metierParam}"]`)
    const categoryList =
      this.categoryParam &&
      document.querySelector(`.dropdown__list_item[data-value="${this.categoryParam}"]`)
    metierList && metierList.click()
    categoryList && categoryList.click()

    if (this.device === 'mobile') {
      this.elements.mobileFilter.forEach((elm) => {
        if (elm.dataset.filter === 'metier' && elm.dataset.value === this.metierParam) {
          //remove active class for other buttons and add active class to the clicked button
          const siblings = elm.parentNode.children
          for (let i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('active')
          }
          elm.classList.add('active')
          // elm.click()
        }
        if (elm.dataset.filter === 'category' && elm.dataset.value === this.categoryParam) {
          //remove active class for other buttons and add active class to the clicked button
          const siblings = elm.parentNode.children
          for (let i = 0; i < siblings.length; i++) {
            siblings[i].classList.remove('active')
          }
          elm.classList.add('active')
          // elm.click()
        }
      })
    }
    //
    if (this.metierParam || this.categoryParam) {
      this.updateCategoryList(this.metierParam)
      this.getProjects({
        metier: this.metierParam,
        category: this.categoryParam,
        layout: Object.values(this.elements.layout).filter((elm) =>
          elm.classList.contains('active')
        )[0].dataset.layout,
      })
    } else {
      this.loadData()
    }
    //
    this.tracker = new Tracker()
    //
    this.filterProjects()
    //
  }

  updateUrlParam(input) {
    const url = new URL(window.location.href)
    //delete param if empty
    if (input.value === '') {
      url.searchParams.delete(input.name)
    } else {
      url.searchParams.set(input.name, input.value)
    }
    //push state
    window.history.pushState({}, '', url)
  }

  filterProjects() {
    this.elements.filterInput.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.name === 'metier') {
          // this.elements.category.value = ''
          this.updateCategoryList(this.elements.metier.value)
        } else {
          // update projects
          this.getProjects({
            category: this.elements.category.value,
            // date: this.elements.date.value,
            metier: this.elements.metier.value,
            layout: Object.values(this.elements.layout).filter((elm) =>
              elm.classList.contains('active')
            )[0].dataset.layout,
          })
        }
        //update url
        this.updateUrlParam(input)
      })
    })

    this.elements.layout.forEach((elm) => {
      elm.addEventListener(
        'click',
        (e) => {
          e.preventDefault()
          this.elements.layout.forEach((el) => el.classList.remove('active'))
          e.target.classList.add('active')
          // console.log(this.elements.category.value, this.elements.metier.value, e.target.dataset.layout)
          this.getProjects({
            category:
              this.device === 'mobile'
                ? [...this.elements.mobileFilter].filter(
                    (elm) => elm.classList.contains('active') && elm.dataset.filter === 'category'
                  )[0].dataset.value
                : this.elements.category.value,
            // date: this.elements.date.value,
            metier:
              this.device === 'mobile'
                ? [...this.elements.mobileFilter].filter(
                    (elm) => elm.classList.contains('active') && elm.dataset.filter === 'metier'
                  )[0].dataset.value
                : this.elements.metier.value,
            layout: e.target.dataset.layout,
          })
        },
        false
      )
    })
  }

  async layout(data, type = 'list') {
    let layout = ''
    if (type === 'grid') {
      layout = await Promise.all(
        data.map(
          async (item) => ` <div class="module__vignette is__hidden" data-scroll="true">
                                                              <picture class="module__vignette_img" data-modal="realisation" data-id="${
                                                                item.id
                                                              }" data-module="projets"> 
                                                                <img src="${await getEmbeddedFeaturedImg(
                                                                  item._embedded
                                                                )}" alt="${item.title.rendered}">
                                                              </picture>
                                                              <div class="module__vignette_text">
                                                                <h4 class="text__medium">${
                                                                  item.title.rendered
                                                                }</h4>
                                                                <div class="module__cat_wrapper"><span class="spacer__line"></span><span> ${await getEmbeddedTerm(
                                                                  item._embedded
                                                                )}</span></div>
                                                              </div>
                                                            </div>`
        )
      )
    } else {
      layout = await Promise.all(
        data.map(
          async (
            item
          ) => `<div class="module__item is__hidden" data-animation="reveal" data-img="${await getEmbeddedFeaturedImg(
            item._embedded
          )}">
                                  <a class="animateImg" href="" data-modal="realisation" data-id="${
                                    item.id
                                  }" data-module="projets"> 
                                  <span class="module__item_title">${item.title.rendered}</span>
                                    <div class="dis__flex"> 
                                      <span class="module__spacer"></span>
                                      <span class="module__item_cat"> ${await getEmbeddedTerm(
                                        item._embedded
                                      )}</span>
                                    </div>
                                  </a>
                                </div>`
        )
      )
    }

    return layout.join('')
  }

  async imgData(data) {
    const projectsImg = await Promise.all(
      data.map(
        async (item) =>
          `<div class="realisationImg_item"><img src="${await getEmbeddedFeaturedImg(
            item._embedded
          )}" alt="${item.title.rendered}"></div>`
      )
    )
    return projectsImg.join('')
  }

  storeData(data) {
    // console.log('storeData')
    const dataToStore = data.map((item) => ({
      id: item.id,
      title: item.title.rendered,
      featuredimg: item._embedded['wp:featuredmedia'][0]
        ? item._embedded['wp:featuredmedia'][0]?.media_details.sizes.nextImg.source_url
        : null,
    }))
    localStorage.setItem('projets', JSON.stringify(dataToStore))
  }

  async loadData() {
    try {
      // let { data } = await axios.get(
      //   `${process.env.API}/projets?orderby=title&order=asc&per_page=100&lang=${this.lang}&_embed`
      // )
      //check if data exist in localstorage

      let { data } = await axios({
        method: 'get',
        url: `${process.env.SGTMAPI}/proxy`,
        params: {
          endpoint: 'projets',
          orderby: 'title',
          order: 'asc',
          perPage: 100, // will be mapped to 'per_page' in the request params
          lang: this.lang,
          _embed: true,
        },
      })

      this.storeData(data)
    } catch (error) {
      console.log(error.message)
    }
  }

  async getProjects(filters) {
    // console.log(filters)
    //Retrieve data
    // // const { data } = await axios.get(`${process.env.API}/projets?orderby=date&order=${filters.date}&_embed`)
    // let { data } = await axios.get(
    //   `${process.env.API}/projets?orderby=title&order=asc&per_page=100&lang=${this.lang}&_embed`
    // )

    let { data } = await axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: 'projets',
        orderby: 'title',
        order: 'asc',
        perPage: 100, // will be mapped to 'per_page' in the request params
        lang: this.lang,
        _embed: true,
      },
    })

    //Filter data
    data = filters.metier
      ? data?.filter((item) => item.acf.metier == parseInt(filters.metier))
      : data
    data = filters.category
      ? data?.filter((item) => item.project_cat.indexOf(parseInt(filters.category)) !== -1)
      : data
    const length = data?.length
    const projects = await this.layout(data, filters.layout)

    //store filtred data (id, title and featured image) in localstorage
    this.storeData(data)

    //update HTML
    this.elements.count.innerText = length
    this.elements.mobileCount.innerText = length
    this.elements.paginationLink.dataset.count = length
    this.elements.paginationLink.dataset.page = 1
    this.elements.moduleWrapper.innerHTML = projects

    if (filters.layout == 'list') {
      this.elements.moduleWrapper.classList.remove('vignette__wrapper')
      const projectsImg = await this.imgData(data)
      this.elements.moduleImgItemsWrapper.innerHTML = projectsImg

      this.tracker.removeEventsListeners()
      this.tracker = new Tracker()
    } else {
      this.elements.moduleWrapper.classList.add('vignette__wrapper')
      this.elements.moduleImgItemsWrapper.innerHTML = ''
      this.tracker.removeEventsListeners()
    }

    if (this.elements.paginationLink.dataset.perpage >= length) {
      this.elements.paginationLink.classList.add('is__hidden')
    } else {
      this.elements.paginationLink.classList.remove('is__hidden')
    }

    //Reinit components
    this.initPagination()
    this.initModal()
    this.show()
    this.emitEvent()
  }

  emitEvent() {
    window.dispatchEvent(new Event('resize'))
  }

  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    return super.onResize()
  }
}
